<template>
	<div>
		<v-dialog v-model="getPreload" hide-overlay persistent width="300" class="listpreload">
			<v-card color="primary" dark>
				<v-card-text>
					Loading
					<v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
				</v-card-text>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
	name: 'Loading',
	computed: {
		...mapGetters({
			getPreload: 'settings/getPreload',
		}),
	},
};
</script>

<style scoped></style>
